import { lazyWithRetry } from "utils/lazyWithRetry";

// Auth routes
export const Login = lazyWithRetry(() => import("pages/Auth/components/Login"));
export const ForgotPassword = lazyWithRetry(() => import("pages/Auth/components/ForgotPassword"));
export const CreateNewPassword = lazyWithRetry(() => import("pages/Auth/components/CreateNewPassword"));

// Dashboard routes
export const AppointmentsDashboard = lazyWithRetry(() => import("pages/Dashboard/AppointmentsDashbaord"));
export const PatientDashboard = lazyWithRetry(() => import("pages/Dashboard/PatientDashboard"));
export const OpenEncountersDashboard = lazyWithRetry(() => import("pages/Dashboard/OpenEncountersDashboard"));
export const PatientDetail = lazyWithRetry(() => import("pages/Dashboard/PatientDetail"));
export const SettingsWrapper = lazyWithRetry(() => import("pages/Dashboard/Settings/Wrapper"));
export const AnnotationInterface = lazyWithRetry(() => import("pages/AnnotationInterface"));
export const EndVisitStepper = lazyWithRetry(() => import("pages/Dashboard/PatientDetail/components/EndVisit/EndVisitStepper"));

// Other routes
export const NotFound = lazyWithRetry(() => import("pages/NotFound"));
